import React from 'react';
import { createFromIconfontCN } from '@ant-design/icons';
import classNames from 'classnames';
export { PICTOGRAM_CATEGORIES } from './config';
import { globalConfig } from '../config-provider';
export { pictogramProps } from './util';
const PictogramFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_3488573_2666c34milp.js',
    extraCommonProps: { className: globalConfig().getIconPrefixCls() }
});
export const Pictogram = (props) => {
    // const { prefixCls = 'b-design-icon' } = React.useContext(IconContext);
    const prefixCls = 'b-design-icon';
    const { className: customizeClassName, size, type: customizeType, ...otherProps } = props;
    const className = classNames('b-design-icon', {
        [`${prefixCls}-pictogram-sm`]: size === 'small',
        [`${prefixCls}-pictogram-md`]: size === 'middle',
        [`${prefixCls}-pictogram-lg`]: size === 'large',
        [`${prefixCls}-pictogram-xl`]: size === 'xl',
        [`${prefixCls}-pictogram-xs`]: size === 'xs'
    }, customizeClassName);
    // @ts-ignore
    return React.createElement(PictogramFont, { className: className, type: props.type, ...otherProps });
};
export default Pictogram;
// export default withConfigProvider(Icon);
